import { useUser } from '@gik/api/users/user';
import { useUserStore } from '@gik/core/store/UserStore';
import React from 'react';
import { useIntercom } from 'react-use-intercom';

export function IntercomIdentifier() {
  const intercom = useIntercom();
  const userId = useUserStore(store => store.id);
  const { data: user } = useUser(userId);
  React.useEffect(() => {
    intercom.update({
      ...(user
        ? {
            email: user.emailAddress,
            name: user.fullName,
            userId: user.id,
          }
        : {}),
      customAttributes: {
        application: 'nextjs',
      },
    });
  }, [user, intercom]);
  return null;
}
